import { render } from "./BaseTabPanel.vue?vue&type=template&id=cae08b00&scoped=true"
import script from "./BaseTabPanel.vue?vue&type=script&lang=js"
export * from "./BaseTabPanel.vue?vue&type=script&lang=js"

import "./BaseTabPanel.vue?vue&type=style&index=0&id=cae08b00&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cae08b00"]])

export default __exports__